/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Hint_Message_AfterInputs */

const en_paste_hint_message_after = /** @type {(inputs: Paste_Hint_Message_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to paste directly into the table. Select which cell is the starting point just like in Excel!`)
};

const nl_paste_hint_message_after = /** @type {(inputs: Paste_Hint_Message_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`om direct in de tabel te plakken. Selecteer de begincel net zoals in Excel!`)
};

/**
* | output |
* | --- |
* | "to paste directly into the table. Select which cell is the starting point just like in Excel!" |
*
* @param {Paste_Hint_Message_AfterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const paste_hint_message_after = /** @type {((inputs?: Paste_Hint_Message_AfterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Hint_Message_AfterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_paste_hint_message_after(inputs)
	return en_paste_hint_message_after(inputs)
});